import r from '../Utils/fetch';
import { green, red, blue, grey, orange, blueGrey } from '@mui/material/colors';

const w: any = window;
// api-connectors-v2: the admin yml routes were ported from v1 (QV2-4910).
const endPoint = `${w.API_CONNECTORS_CONFIG_URL}`;

export interface IStatus {
	id: number;
	name: string;
	color?: string;
}

export const CONNECTOR_NOT_CONFIGURED = 0,
	CONNECTOR_PENDING_PROGRESS = 70,
	CONNECTOR_IN_PROGRESS = 100,
	CONNECTOR_PAUSED = 150,
	CONNECTOR_READY = 200,
	CONNECTOR_ERROR = 300,
	CONNECTOR_DELETED = 500;

export const ConnectorAccountStatusLst: IStatus[] = [
	{
		id: CONNECTOR_NOT_CONFIGURED,
		name: 'Incomplete',
		color: grey[500],
	},
	{
		id: CONNECTOR_PENDING_PROGRESS,
		name: 'Pending',
		color: orange[500],
	},
	{
		id: CONNECTOR_IN_PROGRESS,
		name: 'Syncing',
		color: blue[500],
	},
	{
		id: CONNECTOR_PAUSED,
		name: 'Paused',
		color: blueGrey[500],
	},
	{
		id: CONNECTOR_READY,
		name: 'Active',
		color: green[500],
	},
	{
		id: CONNECTOR_ERROR,
		name: 'Broken',
		color: red[500],
	},
	{
		id: CONNECTOR_DELETED,
		name: 'Deleted',
		color: red[500],
	},
];

export const getYml = (folderId: string, sku: string, accountId: string): any =>
	r({
		url: `${endPoint}/v1/admin/connector-accounts/${folderId}/${sku}/${accountId}/yml`,
		method: 'GET',
	});

export const patchYml = (
	folderId: string,
	sku: string,
	accountId: string,
	data: any
): any =>
	r({
		url: `${endPoint}/v1/admin/connector-accounts/${folderId}/${sku}/${accountId}/yml`,
		method: 'PATCH',
		data,
	});
